require('./RADissociateObjectiveView.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');
const moment = require('moment');

// @commons
const RACover = require('../../components/commons/RACover/RACover');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const RADissociateObjectiveSuccess = require('./RADissociateObjectiveSuccess/RADissociateObjectiveSuccess');
const PrinterPreviewManagerButton = require('components/contactCenter/printer/printerPreviewManagerButton');
const {
    PrinterPreviewManager,
} = require('components/contactCenter/printer/printerPreviewManager');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @constants
const { BROKER_PG_URL, LOADING, EURO_SYMBOL } = require('constants/index');
const {
    DATE_FORMAT,
    MYPROFILE_BROKER_ROBO_URL,
    RA_COVER_FONT,
    GOAL_TRACKING_URL,
    PORTFOLIO_TRACKING_URL,
} = require('../../raConstants/index');

const riskTextByStrategy = {
    1: 'raStrategyItem-lowRisk',
    2: 'raStrategyItem-midLowRisk',
    3: 'raStrategyItem-midRisk',
    4: 'raStrategyItem-midHighRisk',
    5: 'raStrategyItem-highRisk',
};

// @assets
const carImage = require('../../assets/icons/coche.png');
const travelImage = require('../../assets/icons/viaje.png');
const homeImage = require('../../assets/icons/casa.png');
const educationImage = require('../../assets/icons/educacion.png');
const otherImage = require('../../assets/icons/otro.png');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const CurrencyHelper = require('utilities/currencyHelper');
const { Portfolios } = require('../../utilities/RAPortfolioHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @components
const RAObjectiveDetails = require('../../components/RAObjectiveDetails/RAObjectiveDetails');
const RACgdNumber = require('../../components/RACgdNumber/RACgdNumber');

// @actions
const brokerMyInvestments = require('actions/brokerMyInvestments');
const raObjectiveDetailsActions = require('../../actions/RAObjectiveDetails');
const raAccountDetailsActions = require('../../actions/RAAccountDetails');
const raDissociateObjective = require('../../actions/RADissociateObjective');

class RADissociateObjectiveView extends React.Component {
    constructor(props) {
        super(props);

        this.handleDissociateObjective = this.handleDissociateObjective.bind(
            this,
        );
    }

    componentDidMount() {
        const {
            fetchMyInvestments,
            readPortfolioFromGlobalPosition,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
            getCGDAccountNumberVal,
        } = this.props;

        getCGDAccountNumberVal(portfolioId);

        if (!immGlobalPosition.get('hasRoboHired')) {
            fetchMyInvestments().then(() => {
                readPortfolioFromGlobalPosition(portfolioId);
            });
        } else {
            readPortfolioFromGlobalPosition(portfolioId);
        }
    }

    componentWillUnmount() {
        this.props.resetDissociateObjective();
    }

    getBreadcrumb(portfolioId) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: BROKER_PG_URL,
            },
            {
                text: formatText('breadcrumb-breadcrumb_roboLanding'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText('breadcrumb-breadcrumb_objectiveTracking'),
                url: `${GOAL_TRACKING_URL}/${portfolioId}`,
            },
            {
                text: formatText('breadcrumb-breadcrumb_quitObjective'),
            },
        ];
    }

    handleDissociateObjective() {
        this.props.dissociateObjective(
            this.props.match.params.portfolioId,
            this.props.history,
        );
    }

    getPortfolioIcon() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const productCode = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'product',
            'typeOfProduct',
        ]);
        const iconClassName = classnames(
            'ra-summary-widget__icon-product',
            `ra-summary-widget__icon-product--${productCode}`,
        );
        return iconClassName;
    }

    getGoalIconImage(goalType) {
        switch (goalType) {
            case 'CAR':
                return carImage;
            case 'TRAVEL':
                return travelImage;
            case 'HOME':
                return homeImage;
            case 'EDUCATION':
                return educationImage;
            case 'OTHERS':
                return otherImage;
            default:
                return '';
        }
    }

    buildLegalTextSection(textArray, hasHeader) {
        const textElements = textArray.map((textObject, index) => (
            <FormattedText
                key={index}
                className="ra-dissociate-objective-view__block-info-text"
                value={textObject.value}
                injectedStrings={textObject.injectedStrings}
            />
        ));

        const blockInfoElement = (
            <BlockInfo extraClass="ra-dissociate-objective-view__block-info">
                <FormattedText
                    className="ra-dissociate-objective-view__block-info-title"
                    value="raStrategiesGraph-raStrategiesGraph_legalTextTitle"
                />
                {textElements}
            </BlockInfo>
        );

        let legalTextBody;
        if (hasHeader) {
            legalTextBody = (
                <div className="ra-dissociate-objective-view__operation-summary-wrapper">
                    <h2 className="ra-dissociate-objective-view__operation-summary-title">
                        <FormattedText
                            className="ra-dissociate-objective-view__primary-info"
                            value="raAssociateObjective-raAssociateObjective_legalSummarySectionTitle"
                        />
                    </h2>
                    {blockInfoElement}
                </div>
            );
        } else {
            legalTextBody = blockInfoElement;
        }

        return (
            <ContactCenterRender>
                <div className="row">
                    <div className="col-md-12 ra-dissociate-objective-view__legal-text-container">
                        {legalTextBody}
                    </div>
                </div>
            </ContactCenterRender>
        );
    }

    buildPrintPriviewContent() {
        const {
            immProfile,
            immObjectiveDetailsReducer,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const clientName = immProfile.get('nombreCompleto');
        const objectiveName = immObjectiveDetailsReducer.getIn([
            'name',
            'value',
        ]);
        const currentStrategyCode = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'product',
            'typeOfProduct',
        ]);
        const strategyName = formatText(
            `raStrategyItem-raStrategyItem_${currentStrategyCode}`,
        );

        return (
            <ContactCenterRender>
                <div
                    id="printable-wizard"
                    className="ra-dissociate-objective-view__print"
                >
                    <FormattedText
                        className="ra-dissociate-objective-view__print-subtitle"
                        value="raDissociateObjective-raDissociateObjective_printCCSubtitle"
                        injectedStrings={[clientName]}
                    />
                    <FormattedText
                        className="ra-dissociate-objective-view__print-item"
                        value="raDissociateObjective-raDissociateObjective_printCCItem1"
                        injectedStrings={[objectiveName]}
                    />
                    <FormattedText
                        className="ra-dissociate-objective-view__print-item"
                        value="raDissociateObjective-raDissociateObjective_printCCItem2"
                        injectedStrings={[strategyName]}
                    />
                </div>
            </ContactCenterRender>
        );
    }

    buildStrategyTrackingLink(portfolioId) {
        const startegyTrackingUrl = `${PORTFOLIO_TRACKING_URL}/${portfolioId}`;
        return (
            <OKLink
                modifier="inherit-styles"
                to={startegyTrackingUrl}
                extraClass="ra-dissociate-objective-success__info-content-strategylink"
            >
                <FormattedText value="raDissociateObjective-raDissociateObjective_strategyLinkText" />
            </OKLink>
        );
    }

    buildDissociateObjectiveSection(
        isFetchingDetail,
        objectiveType,
        goalProgress,
        amountVal,
        objectiveEndDate,
        probability,
        actualAmount,
        profitabilityAmount,
        profitabilityWeighted,
        initialInvestmentAmount,
        contributionAmount,
        refundAmount,
        portfolioId,
        productName,
        productIcon,
        displayStrategyDetail,
        objectiveDetailModalLinkText,
        objectiveName,
        portfolioName,
        clientName,
    ) {
        const printPriviewContent =
            isPrintOfficeMode() && this.buildPrintPriviewContent();
        const actualAmountFormatted = CurrencyHelper.getFormattedString({
            amount: actualAmount,
            currency: EURO_SYMBOL,
        });

        const legalTextFirst = this.buildLegalTextSection(
            [
                {
                    value:
                        'raDissociateObjective-raDissociateObjective_legalText1',
                    injectedStrings: [clientName],
                },
                {
                    value:
                        'raDissociateObjective-raDissociateObjective_legalText2',
                },
                {
                    value:
                        'raDissociateObjective-raDissociateObjective_legalText3',
                },
            ],
            false,
        );

        const legalTextSecond = this.buildLegalTextSection(
            [
                {
                    value:
                        'raDissociateObjective-raDissociateObjective_operationSummarylegalText1',
                    injectedStrings: [clientName],
                },
                {
                    value:
                        'raDissociateObjective-raDissociateObjective_operationSummarylegalText2',
                    injectedStrings: [
                        objectiveName,
                        portfolioName,
                        actualAmountFormatted,
                    ],
                },
                {
                    value:
                        'raDissociateObjective-raDissociateObjective_operationSummarylegalText3',
                    injectedStrings: [clientName],
                },
            ],
            true,
        );

        return (
            <div className="ra-dissociate-objective-view grid-view">
                <div className="row ra-dissociate-objective-view__container">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 grid-view--fix-cell-separation">
                                    <RAObjectiveDetails
                                        isFetching={isFetchingDetail}
                                        goalType={objectiveType}
                                        goalProgress={goalProgress}
                                        objectiveAmount={amountVal}
                                        objectiveEndDate={objectiveEndDate}
                                        probability={probability}
                                        actualAmount={actualAmount}
                                        profitabilityAmount={
                                            profitabilityAmount
                                        }
                                        profitabilityWeighted={
                                            profitabilityWeighted
                                        }
                                        initialInvestmentAmount={
                                            initialInvestmentAmount
                                        }
                                        contributionAmount={contributionAmount}
                                        refundAmount={refundAmount}
                                        portfolioId={portfolioId}
                                        productName={productName}
                                        productIcon={productIcon}
                                        displayStrategyDetail={
                                            displayStrategyDetail
                                        }
                                        modalLinkText={
                                            objectiveDetailModalLinkText
                                        }
                                        hideGoalStatus={true}
                                    />
                                </div>
                            </div>
                            <WebappRender>
                                <div className="row">
                                    <div className="col-md-12 ra-dissociate-objective-view__disclaimer-container">
                                        <OKMessage
                                            type="informative"
                                            modifier="dark-bg"
                                        >
                                            <FormattedText value="raDissociateObjective-raDissociateObjective_objectiveRemovalDisclaimer" />
                                        </OKMessage>
                                    </div>
                                </div>
                            </WebappRender>
                            {legalTextFirst}
                            {legalTextSecond}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="ra-dissociate-objective-view__ctabutton-container clearfix">
                                        <span className="pull-left">
                                            <PrinterPreviewManager />
                                        </span>
                                        <span className="pull-right">
                                            <ContactCenterRender>
                                                <PrinterPreviewManagerButton
                                                    onClick={ // eslint-disable-line
                                                        this
                                                            .handleDissociateObjective
                                                    }
                                                >
                                                    <FormattedText value="raDissociateObjective-raDissociateObjective_quitObjectiveButton" />
                                                </PrinterPreviewManagerButton>
                                            </ContactCenterRender>
                                            <WebappRender>
                                                <OKButton
                                                    onClick={ // eslint-disable-line
                                                        this
                                                            .handleDissociateObjective
                                                    }
                                                >
                                                    <FormattedText value="raDissociateObjective-raDissociateObjective_quitObjectiveButton" />
                                                </OKButton>
                                            </WebappRender>
                                        </span>
                                    </div>
                                    {printPriviewContent}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildSuccessSection(
        formattedDate,
        goalIcon,
        headingTitle,
        mappingBreadcrumb,
        objectiveName,
        hasPeriodicity,
        portfolioTrackingUrl,
        productIcon,
        strategyTrackingLink,
        updatedStrategyName,
    ) {
        return (
            <RADissociateObjectiveSuccess
                endDate={formattedDate}
                goalIcon={goalIcon}
                headingTitle={headingTitle}
                mappingBreadcrumb={mappingBreadcrumb}
                name={objectiveName}
                hasPeriodicity={hasPeriodicity}
                portfolioTrackingUrl={portfolioTrackingUrl}
                productIcon={productIcon}
                productName={updatedStrategyName}
                strategyTrackingLink={strategyTrackingLink}
            />
        );
    }

    buildContent() {
        const {
            immObjectiveDetailsReducer,
            immAccountDetails,
            immGlobalPosition,
            immRADissociateObjective,
            immProfile,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const currentStrategyCode = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'product',
            'typeOfProduct',
        ]);
        const mappingBreadcrumb = this.getBreadcrumb(portfolioId);
        const clientName = immProfile.get('nombreCompleto');
        const isFetchingDetail = immObjectiveDetailsReducer.get(
            'isFetchingDetail',
        );
        const goalType = immObjectiveDetailsReducer.get('goalType');
        const immObjectiveKeyFigures = immObjectiveDetailsReducer.get(
            'keyFigures',
        );
        const actualAmount = immObjectiveKeyFigures.get('valuation');
        const totalDeposits = immObjectiveKeyFigures.get('deposits') || 0;
        const initialInvestmentAmount =
            immObjectiveKeyFigures.get('initialInvestment') || 0;
        const contributionAmount = totalDeposits - initialInvestmentAmount;
        const probability = immObjectiveDetailsReducer.get('probability');
        const profitabilityAmount = immObjectiveKeyFigures.get('netReturn');
        const profitabilityWeighted = immObjectiveKeyFigures.get(
            'timeWeightedReturn',
        );
        const refundAmount = immObjectiveKeyFigures.get('withdrawals');

        const name =
            immObjectiveDetailsReducer.getIn(['name', 'value']) || LOADING;
        const headingTitle = (
            <FormattedText
                value="raDissociateObjective-raDissociateObjective_dissociateObjectiveHeader"
                injectedStrings={[name]}
            />
        );
        const amountVal = immObjectiveDetailsReducer.getIn([
            'editAmountModal',
            'objectiveAmount',
        ]);
        const productIcon = this.getPortfolioIcon();
        const portfolioName = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'name',
        ]);
        const currentStrategyRisk = formatText(
            riskTextByStrategy[currentStrategyCode],
        );
        const currentStrategyInfo = Portfolios[currentStrategyCode];
        const currentStrategyName = currentStrategyInfo
            ? currentStrategyInfo.portfolioName
            : '';
        const productName = `${currentStrategyName} - ${currentStrategyRisk}`;
        const objectiveDetailModalLinkText = formatText(
            'raDissociateObjective-raDissociateObjective_modelTitleForObjectivo',
        );
        const goalTrackingUrl = `${GOAL_TRACKING_URL}/${portfolioId}`;
        const goalProgress = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'goalInformation',
            'goalProgress',
        ]);

        const successTitle = formatText(
            'raDissociateObjective-raDissociateObjective_dissociateObjectiveSuccessHeader',
        );
        const goalIcon = this.getGoalIconImage(goalType);
        const objectiveName = immObjectiveDetailsReducer.getIn([
            'name',
            'value',
        ]);
        const hasPeriodicity =
            immObjectiveDetailsReducer.getIn(['periodicTransfer', 'amount']) >
            0;
        const objectiveEndDate = immObjectiveDetailsReducer.get(
            'objectiveEndDate',
        );
        const formattedDate = DateHelper.buildFormattedDate(
            moment(objectiveEndDate),
            DATE_FORMAT,
        );
        const portfolioTrackingUrl = `${PORTFOLIO_TRACKING_URL}/${portfolioId}`;
        const isSubmitSuccessful = immRADissociateObjective.get(
            'submitSuccessFull',
        );
        const updatedStrategyName = immRADissociateObjective.get(
            'updatedStrategyName',
        );
        const strategyTrackingLink = this.buildStrategyTrackingLink(
            portfolioId,
        );

        const rightContent = !isSubmitSuccessful && (
            <OKButton
                modifier="ghost"
                leftIcon="icon-anterior"
                inverse={true}
                to={goalTrackingUrl}
            >
                <FormattedText value="raDissociateObjective-raDissociateObjective_backButtonText" />
            </OKButton>
        );

        let cgdNumber, subtitle;
        if (immAccountDetails) {
            cgdNumber = immAccountDetails.get('cgdNumber');
            if (cgdNumber) {
                subtitle = <RACgdNumber cgdNumberVal={cgdNumber} />;
            }
        }

        let content;

        if (immObjectiveDetailsReducer.get('isFetchingDetail')) {
            content = <LoadingSection />;
        } else if (isSubmitSuccessful) {
            content = this.buildSuccessSection(
                formattedDate,
                goalIcon,
                headingTitle,
                mappingBreadcrumb,
                objectiveName,
                hasPeriodicity,
                portfolioTrackingUrl,
                productIcon,
                strategyTrackingLink,
                updatedStrategyName,
            );
        } else if (immObjectiveDetailsReducer.get('isSuccess')) {
            content = this.buildDissociateObjectiveSection(
                isFetchingDetail,
                goalType,
                goalProgress,
                amountVal,
                objectiveEndDate,
                probability,
                actualAmount,
                profitabilityAmount,
                profitabilityWeighted,
                initialInvestmentAmount,
                contributionAmount,
                refundAmount,
                portfolioId,
                productName,
                productIcon,
                true,
                objectiveDetailModalLinkText,
                objectiveName,
                portfolioName,
                clientName,
            );
        }

        return (
            <div className="ra-dissociate-objective-view grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={mappingBreadcrumb}
                            section="goal"
                            goalType={immObjectiveDetailsReducer.get(
                                'goalType',
                            )}
                            showHelp={false}
                            success={isSubmitSuccessful}
                            title={headingTitle}
                            successTitle={successTitle}
                            titleEditable={false}
                            rightContent={rightContent}
                            fontSize={RA_COVER_FONT}
                            subtitle={subtitle}
                        />
                    </div>
                </div>
                {content}
            </div>
        );
    }

    render() {
        const dissociateObjectiveView = this.buildContent();

        return <React.Fragment>{dissociateObjectiveView}</React.Fragment>;
    }
}

RADissociateObjectiveView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccountDetails: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immObjectiveDetailsReducer: PropTypes.object,
    immRADissociateObjective: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    dissociateObjective: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    getCGDAccountNumberVal: PropTypes.func.isRequired,
    readPortfolioFromGlobalPosition: PropTypes.func.isRequired,
    resetDissociateObjective: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountDetails: state.raAccountDetails,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immObjectiveDetailsReducer: state.raObjectiveDetailsReducer,
        immGlobalPosition: state.raGlobalPosition,
        immRADissociateObjective: state.raDissociateObjective,
        immProfile: state.profile,
    }),
    {
        dissociateObjective: raDissociateObjective.dissociateObjective,
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        getCGDAccountNumberVal: raAccountDetailsActions.getCGDAccountNumber,
        readPortfolioFromGlobalPosition:
            raObjectiveDetailsActions.readPortfolioFromGlobalPosition,
        resetDissociateObjective:
            raDissociateObjective.resetDissociateObjective,
    },
)(withRouter(RADissociateObjectiveView));
